import { Component, OnInit, ElementRef, Renderer2, Input, Output, EventEmitter, OnChanges, SimpleChanges, SimpleChange } from '@angular/core';

@Component({
  selector: 'app-color-bar',
  templateUrl: './color-bar.component.html',
  styleUrls: ['./color-bar.component.scss']
})
export class ColorBarComponent implements OnInit, OnChanges {

  constructor(public element: ElementRef, public renderer: Renderer2) { }

  @Input() onTarget: number;
  @Input() offTarget: number;
  @Input() projectId: number;

  @Input() shippedSkusCount: number;
  @Input() deliveredSkusCount: number;

  onTargetSkusPercentage: number = 0;
  offTargetSkusPercentage: number = 0;;
  shippedSkusPercentage: number = 0;;
  deliveredSkusPercentage: number = 0;;

  total = 0;

  setBarValue(className, value) {
    let calculatedValue = (value / this.total) * 100;
    let finalValue = calculatedValue % 1 ? calculatedValue.toFixed(1).replace(/\.0$/, '') : calculatedValue;
    if (this.element.nativeElement.querySelector(className)) {
      this.renderer.setStyle(this.element.nativeElement.querySelector(className), 'width', `${finalValue}%`)
    }
    if (isNaN(Number(finalValue))) {
      finalValue =  Number(0);
    }
    switch (className) {
      case ".on-target-bar":
        this.onTargetSkusPercentage = Number(finalValue);
        break;
      case ".off-target-bar":
        this.offTargetSkusPercentage = Number(finalValue);
        break;
      case ".shipped-skus-bar":
        this.shippedSkusPercentage = Number(finalValue);
        break;
      case ".delivered-skus-bar":
        this.deliveredSkusPercentage = Number(finalValue);
        break;
      default:
        console.error("Unexpected className:", className);
    }
  }

  ngOnInit() {
    this.total = this.onTarget + this.offTarget + this.shippedSkusCount + this.deliveredSkusCount;
    this.setBarValue('.on-target-bar', this.onTarget);
    this.setBarValue('.off-target-bar', this.offTarget);
    this.setBarValue('.shipped-skus-bar', this.shippedSkusCount);
    this.setBarValue('.delivered-skus-bar', this.deliveredSkusCount);
  }

  ngOnChanges(changes: SimpleChanges): void {
    let onTarget: SimpleChange = changes.onTarget;
    if (onTarget) {
      this.onTarget = onTarget.currentValue;
    }
    let offTarget: SimpleChange = changes.offTarget;
    if (offTarget) {
      this.offTarget = offTarget.currentValue;
    }

    let shippedSkus: SimpleChange = changes.countOfShippedItems;
    if (shippedSkus) {
      this.shippedSkusCount = shippedSkus.currentValue;
    }

    let deliveredSkus: SimpleChange = changes.countOfDeliveredItems;
    if (deliveredSkus) {
      this.deliveredSkusCount = deliveredSkus.currentValue;
    }

    this.total = this.onTarget + this.offTarget + this.shippedSkusCount + this.deliveredSkusCount;
    this.setBarValue('.on-target-bar', this.onTarget);
    this.setBarValue('.off-target-bar', this.offTarget);
    this.setBarValue('.shipped-skus-bar', this.shippedSkusCount);
    this.setBarValue('.delivered-skus-bar', this.deliveredSkusCount);
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/dashboard-my-oasis/dashboard-my-oasis-detail/color-bar/color-bar.component.ts